var $ = require('jquery');
require('./eshop-widgets/jquery.global-filter');


$(function () {
	/********************************************
	 * global filter
	 */
	$('.js_global-filter').globalFilter();

});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/eshop.js